import React from 'react';
import { Tabs } from 'antd';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { StickyTable } from 'datastake-daf/dist/components';
import columns from './columns';

const { TabPane } = Tabs;

const tabs = [
  {
    key: 'incidents',
    label: 'Incidents',
  },
  {
    key: 'mitigationActions',
    label: 'Corrective Actions',
  },
  {
    key: 'other',
    label: 'Other',
  },
];

export default function AssociatedEvents({
  data = {
    incidents: [],
    mitigationActions: [],
    other: [],
  },
}) {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const [, mod] = pathname.split(/\/app\/(pme|cadd)\/view/);

  return (
    <div>
      <Tabs defaultActiveKey={tabs[0].key}>
        {tabs.map((tab) => (
          <TabPane
            tab={`${t(tab.label)}(${(data[tab.key] || []).length})`}
            key={tab.key}
          >
            <StickyTable
              size="small"
              dataSource={data[tab.key]}
              columns={columns(t, mod)[tab.key]}
            />
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
}
